export default {
  appTitle: 'Rep-Councils',
  locales_en_CA: 'English (CA)',
  locales_fr_CA: 'French (CA)',
  continue: 'Continue',
  Back: 'Back',
  home: {
    pageTitle: 'Home Page',
  },
};
